module.exports = __webpack_public_path__ + "img/symbol_0.614e182e.png";